export enum Roles {
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
  Therapist = 'Therapist',
  Listener = 'Listener',
  EnterpriseUser = 'EnterpriseUser',
  InviteUsers = 'InviteUsers',
  InterChatTester = 'InterChatTester',
  CirclesModerator = 'CirclesModerator',
  CircleManager = 'CircleManager',
  EventsManager = 'EventsManager',
  Partner = 'Partner',
  TalksManager = 'TalksManager',
  ViewUserProfile = 'ViewUserProfile',
  ManageUserAttributes = 'ManageUserAttributes',
  ManagePromoCodes = 'ManagePromoCodes',
  ManageSurveys = 'ManageSurveys',
  ManageEventBidding = 'ManageEventBidding',
  ManageAnyoPackages = 'ManageAnyoPackages',
  PhysicalFitnessManager = 'PhysicalFitnessManager',
  EmailTemplatesManager = 'EmailTemplatesManager',
  AnyoPartnerCampaignsManager = 'AnyoPartnerCampaignsManager',
  AdminManageMasterData = 'AdminManageMasterData',
  ManageRuleEngine = 'ManageRuleEngine',
  ManagePolicyControls = 'ManagePolicyControls',
  /** APH-4995 — gates the Anyo Goals admin panel's fleet-wide monitor + support override actions. */
  ManageGoals = 'ManageGoals',
  /** Gates the Reengagement Audit Log admin page (read-only view of the AI re-engagement pipeline's decision/draft/compliance output). */
  ManageReengageAudit = 'ManageReengageAudit',
}
export enum Permissions {
  AddTherapist = 'AddTherapist',
  AdminBookNewSession = 'AdminBookNewSession',
  BytesManager = 'BytesManager',
  ContentManager = 'ContentManager',
  RoutineManager = 'RoutineManager',
  AdminAddPost = 'AdminAddPost',
  AdminManageTherapist = 'AdminManageTherapist',
  AdminManageAppointment = 'AdminManageAppointment',
  AdminManageListener = 'AdminManageListener',
  AdminManagePartner = 'AdminManagePartner',
  AdminManageTherapyPlans = 'AdminManageTherapyPlans',
  ActivateTherapyPlan = 'ActivateTherapyPlan',
  AddExtraSessionToPlanSubscription = 'AddExtraSessionToPlanSubscription',
  AddRecipeInContent = 'AddRecipeInContent',
  AdminManageExpertsRewards = 'AdminManageExpertsRewards',
  AdminShowSurveyResult = 'AdminShowSurveyResult',
  AdminApproveOrRejectEventBid = 'AdminApproveOrRejectEventBid',
  ActivateAnyoPackage = 'ActivateAnyoPackage',
  AddOrUpdateSeasonalTags = 'AddOrUpdateSeasonalTags',
  OverrideSessionStatus = 'OverrideSessionStatus',
  ViewUserLyfisScores = 'ViewUserLyfisScores',
  SendFeedbackToTherapist = 'SendFeedbackToTherapist',
}
